import React from 'react';

import {
  ExperienceContainer,
  ExperienceH1,
  ExperienceWrapper,
  ExperienceCard,
  ExperienceH2,
  Experiences,
  ExperienceH3,
  ExperienceH4,
  ExperienceDesc,
  VerticalBar,
  CircleDot,
} from './ExperienceElements';

const Experience = () => {
  return (
    <ExperienceContainer id="experience">
      <ExperienceWrapper>
        <ExperienceH1>Experience</ExperienceH1>
        <Experiences>
          <ExperienceCard isFirst>
            <VerticalBar isFirst />
            <CircleDot isFirst />
            <ExperienceH2>Senior Project Technical Assistant</ExperienceH2>
            <ExperienceH3>
              e-Yantra, ERTS Lab, Indian Institute of Technology Bombay
            </ExperienceH3>
            <ExperienceH4>June 2023 - Present</ExperienceH4>
            <ExperienceDesc>
              <li>
                Conducted research on grasping algorithms for picking unknown
                objects utilizing a two-finger gripper UR5 robotic arm.
                Developed an Elliptical-based Centroid Grasp method using point
                cloud segmentation. Formulated an unified ROS-based pipeline
                integrating Dexnet, Height Assistive Feature, and Grasp Net
                algorithms to facilitate seamless development.
              </li>
              <li>
                Working on the integration of a mobile robot and a UR5 robotic
                arm, working collaboratively to pick and efficiently sort
                packages within a warehouse for packaging. Implementing using
                ROS with SLAM, Nav2 Stack and MoveIt tools.
              </li>
            </ExperienceDesc>
          </ExperienceCard>
          <div />
          <div />
          <ExperienceCard>
            <VerticalBar isRight />
            <CircleDot isRight />
            <ExperienceH2>Robotics Engineer Intern</ExperienceH2>
            <ExperienceH3>
              Flytbase Labs Pvt. Ltd, Pune, Maharashtra
            </ExperienceH3>
            <ExperienceH4>January 2023 - May 2023</ExperienceH4>
            <ExperienceDesc>
              <li>
                Led the development of a robotics software platform for
                autonomous Beyond Visual Line of Sight (BVLOS) drone operations.
                Created middleware applications for edge devices embedded on
                drones as a ROS developer.
              </li>
              <li>
                Assisted in software programming, conducting modular testing to
                improve algorithm scalability, and providing vital technical
                support to overcome challenges related to drone automation.
              </li>
              <li>
                Implemented waypoint mission planning and failsafe triggering
                services which integrates with common platform for monitoring
                and controlling drones remotely from anywhere across the world.
              </li>
            </ExperienceDesc>
          </ExperienceCard>
          <div />
          <div />
          <ExperienceCard>
            <VerticalBar />
            <CircleDot />
            <ExperienceH2>Research and Development Intern</ExperienceH2>
            <ExperienceH3>
              Kalyani Technologies Ltd (Bharat Forge Ltd), Pune, Maharashtra
            </ExperienceH3>
            <ExperienceH4>July 2022 - December 2022</ExperienceH4>
            <ExperienceDesc>
              <li>
                Collaborated with various digital transformation initiatives,
                focusing on cutting-edge robotics technologies such as ROS,
                LiDAR, SLAM, and Product Development to achieve autonomy
                objectives.
              </li>
              <li>
                Manufactured an autonomous mobile robot for warehouse management
                with 80 kg payload carrying capacity and has holonomic drive
                nature. Integrated SLAM technology to empower the robot with
                autonomous navigation capabilities.
              </li>
              <li>
                Developed a scanning system for the quality inspection of forged
                components. Crafted a mechanism to transform 2D scan data into
                3D point cloud information, introducing a cost-effective
                approach to quality inspection.
              </li>
            </ExperienceDesc>
          </ExperienceCard>
          <div />
          <div />
          <ExperienceCard>
            <VerticalBar isRight />
            <CircleDot isRight />
            <ExperienceH2>Design Engineer Intern</ExperienceH2>
            <ExperienceH3>
              Atlas Copco India Limited, Pune, Maharashtra
            </ExperienceH3>
            <ExperienceH4>October 2021 - March 2022</ExperienceH4>
            <ExperienceDesc>
              <li>
                Worked as a project intern in designing and manufacturing
                electronic product enclosures for Pick to Light and Andon
                development boards
              </li>
            </ExperienceDesc>
          </ExperienceCard>
          <div />
          <div />
          <ExperienceCard>
            <VerticalBar isLast />
            <CircleDot />
            <ExperienceH2>Robotics Engineer Intern</ExperienceH2>
            <ExperienceH3>Insignia Machining, Pune, Maharashtra</ExperienceH3>
            <ExperienceH4>April 2021 - September 2022</ExperienceH4>
            <ExperienceDesc>
              <li>
                Mechanical design and analysis | Motion control systems design
                and kinematics | Manufacturing and inventory management |
                Process planning and optimization
              </li>
            </ExperienceDesc>
          </ExperienceCard>
        </Experiences>
      </ExperienceWrapper>
    </ExperienceContainer>
  );
};

export default Experience;
